import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMedicineTablett: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconMedicineTablett"><Path d="M12.2486 4.24959L4.24861 12.2496C2.17755 14.3207 2.17755 17.6785 4.24861 19.7496C6.31968 21.8207 9.67755 21.8207 11.7486 19.7496L19.7486 11.7496C21.8197 9.67852 21.8197 6.32066 19.7486 4.24959C17.6775 2.17852 14.3197 2.17852 12.2486 4.24959Z" stroke="currentColor"/><Path d="M8.5 8.5L15.5 15.5" stroke="currentColor"/></CentralIconBase>;
});

export default IconMedicineTablett;
